import React, { useState } from 'react';
import {
  Edit,
  SimpleForm,
  TextInput,
  DateInput,
  FormDataConsumer,
  useDataProvider,
  useNotify,
  useRedirect,
} from 'react-admin';
import { FormToolbar } from '../../common/FormToolbar';
import { PurchaseItemsGrid } from './PurchaseItemsGrid';

export const PurchaseEdit = (props: any) => {
  const dataProvider = useDataProvider();
  const notify = useNotify();
  const redirect = useRedirect();
  const [items, setItems] = useState<{ productId: number; code?: string; qty: number }[]>([]);
  const propsObj: any = { ...props };
  
    if (propsObj.permissions) {
      const resourcename = `/${props.resource}`;
      const myPermissions = propsObj.permissions.filter((item: any) => item.NavigateUrl.toLowerCase().trim() === resourcename);
      if (myPermissions.length > 0) {
        const p = myPermissions[0];
        propsObj.hasList = p.View === 1;
        propsObj.hasShow = p.View === 1;
        propsObj.hasEdit = p.Edit === 1;
        propsObj.hasDelete = p.Delete === 1;
        propsObj.hasCreate = p.Create === 1;
        propsObj.hasExport = p.Export === 1;
      }
    }

  const handleSubmit = async (values: any) => {
    try {
      const id = values.id;
      const header = {
        ...values,
        poDate: values.poDate
          ? new Date(values.poDate).toISOString()
          : values.poDate,
      };
      await dataProvider.update('purs', { id, data: header, previousData: values });

      const existing: any = await dataProvider.getList('pur-items', {
        pagination: { page: 1, perPage: 1000 },
        sort: { field: 'id', order: 'ASC' },
        filter: { purId: id },
      });
      const existingMap = new Map<number, any>();
      for (const row of existing.data) {
        existingMap.set(row.productId, row);
      }

      for (const it of items) {
        const row = existingMap.get(it.productId);
        if (row) {
          if (it.qty > 0) {
            await dataProvider.update('pur-items', {
              id: row.id,
              data: { ...row, qty: it.qty },
              previousData: row,
            });
          } else {
            await dataProvider.delete('pur-items', { id: row.id, previousData: row });
          }
          existingMap.delete(it.productId);
        } else if (it.qty > 0) {
          await dataProvider.create('pur-items', {
            data: {
              purId: id,
              productId: it.productId,
              qty: it.qty,
            },
          });
        }
      }

      notify('Purchase updated', { type: 'info' });
      redirect('/purs');
    } catch (e) {
      console.error(e);
      const anyErr: any = e;
      notify(anyErr?.message || 'Error updating purchase', { type: 'warning' });
    }
  };

  return (
    <React.Fragment>
      <Edit title="Edit Purchase" {...props}>
        <SimpleForm
          warnWhenUnsavedChanges
          toolbar={<FormToolbar  onSave={handleSubmit} onClose={props.onClose} onCancel={props.onCancel} {...props} {...propsObj}/>}
          variant="outlined"
          save={handleSubmit}
        >
          <TextInput source="poNo" label="Doc. Serial No." fullWidth disabled />
          <DateInput source="poDate" label="Doc. Date" fullWidth />
          <FormDataConsumer>
            {({ formData }) => (
              <PurchaseItemsGrid
                purId={formData.id}
                onChange={setItems}
              />
            )}
          </FormDataConsumer>
        </SimpleForm>
      </Edit>
    </React.Fragment>
  );
};
